import Backbone from 'backbone';
import {ReportingPeriodEnum} from 'common/proxies/enum-proxy';
import BlockSelectBaseView from 'common/views/block-select-base-view';
import {t} from 'common/utils/translation-util';

Backbone.$ = $;

const PeriodSelectView = BlockSelectBaseView.extend({
  initialize(options) {
    this.$options = $('#periodOptions');
    this.$selected = $('#selectedPeriod');
    this.getLabel = (period) => {
      switch (period.slug) {
        case ReportingPeriodEnum.TODAY.slug:
          return t('today');
        case ReportingPeriodEnum.WEEK.slug:
          return t('this week');
        case ReportingPeriodEnum.MONTH.slug:
          return t('this month');
        case ReportingPeriodEnum.YEAR.slug:
          return t('this year');
        default:
          return '';
      }
    };
    this.getPeriod = (label) => {
      switch (label) {
        case 'today':
          return ReportingPeriodEnum.TODAY;
        case 'this week':
          return ReportingPeriodEnum.WEEK;
        case 'this month':
          return ReportingPeriodEnum.MONTH;
        case 'this year':
          return ReportingPeriodEnum.YEAR;
        default:
      }
    };
    this.getPeriods = () => {
      return [
        ReportingPeriodEnum.TODAY,
        ReportingPeriodEnum.WEEK,
        ReportingPeriodEnum.MONTH,
        ReportingPeriodEnum.YEAR,
      ];
    };
    this.periods = this.getPeriods();
    let timescaleIndex = 0;
    let timescale;
    const configuration = options.settings.configuration;
    if (configuration && configuration.hasOwnProperty('timescale')) {
      timescale = configuration.timescale;
    }
    if (timescale) {
      timescaleIndex = timescale - 1;
    }
    this.selectedItem = this.periods[timescaleIndex];
    this.appendOptions(this.selectedItem);
    const label = this.getLabel(this.selectedItem);
    this.setSelectedText(label);

    if (configuration && configuration.hasOwnProperty('period_select')) {
      const periodSelect = configuration.period_select;
      if (periodSelect === 1) {
        this.lock();
      }
    }
  },
});

export default PeriodSelectView;
